module.exports = __webpack_public_path__ + "img/address.21490a3d.jpg";